import moment from 'moment';
import _ from 'lodash';

export const selectTranscript = ({ transcript }) => transcript;
export const selectCallAudio = (state) => selectTranscript(state).callAudio;
export const selectPeople = (state) =>
  selectTranscript(state).people.filter(({ organizationId }) => !organizationId);

// Moment selectors:
const selectMoment = (state) => moment.parseZone(selectTranscript(state).date);

export const selectTimezone = (state) => selectMoment(state).format('Z');

export const selectOrganizationId = (state) =>
  selectTranscript(state).organizationId
    ? String(selectTranscript(state).organizationId)
    : '-';
export const selectCurrentOrganization = ({
  organizations: {
    list: { data: organizationList = [] },
  },
  transcript,
}) => {
  return organizationList.find(({ id }) => String(id) === transcript.organizationId);
};

export const selectDefaultAttendees = (state) => {
  const organization = selectCurrentOrganization(state);
  const attendees = _.get(organization, 'attendees', []);
  return attendees.map((attendee) => ({ ...attendee, readOnly: true }));
};



// WEBPACK FOOTER //
// ./redux/selectors/transcript.js